import { orderDomainStore } from '../../store';
/**
 * Gets the current status of the order embedded payment.
 */
export const getOrderEmbeddedPaymentStatus = () => {
    return orderDomainStore.data.orderEmbeddedPaymentStatus;
};
//# sourceMappingURL=get-order-embedded-payment-status.js.map